export const gpeOne = [
  {
    intro:
      "We are a group of 6 men headed for shooting practice at Mohi range from Malleswar. On reaching the village junction, we encounter 5 problems. I will divide my group into small groups of 2 each. Discussion for a plan of action will take around 5-10 minutes. We start at 0940 hrs and solve the problems as follows:  ",
  },
  {
    problemN: 1,
    problem: "Saving injured man:",
    solution:
      "We will give first aid to the injured man from the truck, carry him into the truck. Two men along with the duty NCO will go to Malleswar and get the man admitted to a hospital, inform police about the bomb, inform CO about the scenario, and bring targets back with them. ",
    distance: "22 km",
    time: "35-40 minutes",
  },
  {
    problemN: 2,
    problem: "Preventing bomb explosion:",
    solution:
      "Two men along with the villagers will cross the culvert on foot and then take a bicycle from any villagers and go to the school, inform the principal and coast guard authorities about the bomb. Help in evacuating children and staff from the school. Secure the commander. ",
    distance: " 5 km",
    time: "25-30 minutes",
  },
  {
    problemN: 3,
    problem: "Preventing smuggling of drugs:",
    solution:
      "Two men will take bicycles from villagers and head towards the coast guard office near the sea and inform them about the helicopter, drug consignment, and smugglers on lighthouse islands. Accompany them and get smugglers caught red-handed. ",
    distance: "6 km",
    time: "50-60 minutes",
  },
  {
    problemN: 4,
    problem: "Rebuilding the culvert:",
    solution:
      "After completing their own tasks all men along with the villagers will help in rebuilding the culvert with wooden logs and available material. ",
    time: "1-1.5 hours ",
  },
  {
    problemN: 5,
    problem: "Arranging for targets:",
    solution:
      "Two men and NCO already brought with them the targets from Malleswar. ",
    distance: "22 kms",
    time: " 35-40 minutes ",
  },
  {
    final:
      "Finally, all 6 men will meet at village junction around 1230 hrs and head for shooting practice.",
  },
];

export const gpeTwo = [
  {
    intro:
      "We are a group of 8 boys coming from Bagar headed towards our college in Ratanpur. When we stopped at the petrol pump, we encounter 5 problems. I will divide my group into small groups of 2 each. Discussion for the plan of action will take around 5-10 minutes. We start at 5:40 PM and solve the problems as follows:",
  },
  {
    problemN: 1,
    problem: "Saving attendant’s life:",
    solution:
      "We will stop the attendant’s bleeding, carefully carry him into the minibus and rush him towards Bagar city and admit him in the city hospital, and inform the police. One boy will stay with the attendant in the hospital. ",
    distance: "13 km ",
    time: "18-20 minutes",
  },
  {
    problemN: 2,
    problem: "Saving Tota Ram’s life:",
    solution:
      "Two boys will take the attendant’s bicycle and go towards Badli village to alert the villagers and Tota Ram asking him not to leave his house and inform police about anti-social elements hidden near Ferry.  ",
    distance: "2 km ",
    time: "20 minutes",
  },
  {
    problemN: 3,
    problem: "Preventing train from derailing:",
    solution:
      "Four boys will run towards Ferry and cautiously take the motorboat towards the coast guard establishment, two of them will deboard near the railway bridge, and inform the track attendant near the bridge about the removal of fishplates who will inform train driver.",
    distance: "1-1.5 km",
    time: "5-10 minutes",
  },
  {
    problemN: 4,
    problem: "Preventing smuggling of drugs and arms:",
    solution:
      "The two boys will continue towards the coast guard and inform them about the smuggling and exchange of arms going to take place at the Rock. They will accompany the coast guard. ",
    distance: "3-4 km  ",
    time: "15-20 minutes ",
  },
  {
    problemN: 5,
    problem: "Bringing back trophy and medals:",
    solution:
      "One boy will take the van and bring back the trophy and medal from the office.",
    distance: " 13 km ",
    time: "  20-22 minutes  ",
  },
  {
    final:
      "Finally, all 6 men will meet at village junction around 1230 hrs and head for shooting practice.",
  },
];

export const gpeThree = [
  {
    intro:
      "We are a group of 6 men going back to our unit at Dinpur after finishing admn duty. On reaching the village junction and having tea, we encounter 4 problems. I will divide my group into small groups. Discussion for the plan of action will take around a couple of minutes. We start at 1702 hrs and solve the problems as follows:  ",
  },
  {
    problemN: 1,
    problem: "Saving injured officer and driver:",
    solution:
      "We will give first aid to the officer and driver and carry them carefully in the 3 ton and 3 boys will take the 3 ton and move towards Kasol for their further treatment by turning on hazard lights of vehicle and removing windshield completely. Others will radio back to the unit and tell CO about a possible attack on GOC, call for immediate backup and MH ambulance and stop the convoy, and inform them about the whole scenario. ",
    distance: " 2 km ",
    time: " 5-10 minutes",
  },
  {
    problemN: 2,
    problem: "Preventing GOC from crossing bridge:",
    solution:
      "Three men will tag along with the convoy and head towards helipad from kachcha road to avoid dynamite on the bridge and will stop and secure GOC from leaving the helipad. Call for bomb disposal squad from the unit. ",
    distance: "8-9 km  ",
    time: " 30-35 minutes ",
  },
  {
    problemN: 3,
    problem: "Saving head-man of Kasol village:",
    solution:
      "We will stop the coming up convoy, ask men to guard the head-man of Kasol village and eliminate anti-national elements if necessary. ",
  },
  {
    problemN: 4,
    problem: "Saving tea shop owner’s pony:",
    solution:
      "Later another man from the 3 ton will take the pony to the vet in Kasol village.",
    distance: " 2 km  ",
    time: "5-10 minutes ",
  },
  {
    final:
      "Finally, after securing GOC and head-man, diffusion of the bomb, getting officer and driver treated and catching/eliminating anti-national elements, everyone will return to the unit",
  },
];

export const gpeFour = [
  {
    intro:
      "We are a group of 12 friends on our way back to Lalpur. Midway we encounter 5 problems. I will divide my group into small groups of 2 each. Discussion for the plan of action will take around 5-10 minutes. We start at 5:10 PM and solve the problems as follows:  ",
  },
  {
    problemN: 1,
    problem: "Saving injured biker:",
    solution:
      "We will give first aid to the injured biker from our van, ensure he doesn’t take off his helmet and take him towards Sonpur where one boy will get him admitted and two will go to the police station and inform them about thieves and communal riot.  ",
    distance: "12 km  ",
    time: "15-20 minutes  ",
  },
  {
    problemN: 2,
    problem: "Taking care of unconscious man:",
    solution:
      "One friend will help the man in gaining consciousness, calm him and give him water and take him to Banoh village on the bike which the man from Lalpur brought after police arrive. ",
  },
  {
    problemN: 3,
    problem: "Preventing burglary and catching thieves: ",
    solution:
      "Two friends will accompany the man to Manla village and help in catching the thieves with the villagers and hand them over to the police when they arrive. ",
    distance: "  6 km   ",
    time: "20-25 minutes  ",
  },
  {
    problemN: 4,
    problem: "Preventing communal riot:",
    solution:
      "Three friends will accompany police and help them in controlling and preventing the communal riots in the Banoh Village.",
    distance: "5 km   ",
    time: "30-40 minutes  ",
  },
  {
    problemN: 5,
    problem: "Helping man to find his cows:",
    solution:
      "Three friends will walk towards the Syari Jungle and find the man’s cows and assemble them and tie them to a tree so that they don’t escape again. ",
    time: "1-1.5 hours",
  },
  {
    final:
      "Finally, all 12 friends will meet at the crossing point and head towards my home and take care of my family and perform the last rites of my grandmother.",
  },
];

export const gpeFive = [
  {
    intro:
      "We are a group of 8 friends who came to Diggal city for riverside boating. While going to bring drinking water from Almora, I encountered 6 problems. I will take others’ help and solve the problems as follows.  ",
  },
  {
    problemN: 1,
    problem: "Saving Pradhan’s daughter:",
    solution:
      "I will raise alarm for help and meanwhile throw the rope present near well and ask her to hold on to it while I pull her out with help of others. ",
  },
  {
    problemN: 2,
    problem: "Alerting railway attendant about fishplates:",
    solution:
      "I will take a lift from passers-by and rush towards the railway crossing and inform attendant about the removed fishplate and head towards riverside afterward to pick jeep and friends.",
  },
  {
    problemN: 3,
    problem: "Saving girls mauled by tigress:",
    solution:
      "Three friends will take the jeep towards Almora village, go to Pradhan and take guns and a few villagers with them. Gunshots in the air will scare both the tigress and the terrorists. Two will help in rescuing girls, carry them carefully in the jeep, and go towards Arki City for further treatment. Few will stay back and wait for the police to arrive with 2 other friends.",
  },
  {
    problemN: 4,
    problem: "Saving Chief Minister and helping police to catch terrorist:",
    solution:
      "We will inform the police about the presence of terrorists and the road mine intended to kill Chief Minister, 2 of the friends will take the motorboat towards Dilnagar, inform police in person and accompany them. The bomb squad will take care of the road mine while the two of us will head towards Forest with the police to aid others. Meanwhile, police will also inform CM’s convoy. ",
  },
  {
    problemN: 5,
    problem: "Looking after mother:",
    solution:
      "I will take the half-hourly bus towards Diggal City, reach home and take care of the mother. ",
  },
  {
    problemN: 6,
    problem: "Extinguishing haystack on fire:",
    solution:
      "Two friends will help in extinguishing the haystack on fire with water along with other villagers.  ",
  },
  {
    final:
      "Finally, after completion of all tasks, 7 of the friends will meet and head towards Diggal City. ",
  },
];
